// Port of api/fuel/app/classes/controller/api/monty/listing/edit.php
import DB from 'offline/db'
import {
	currentUserId,
	invalid,
	loadOwnedListing,
	persist,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var data = params.data || {}
	var name = String(data.name || '').trim()

	if (!userId) return unauthorised()
	if (!listing || listing.get_template()) return unauthorised()
	if (!name) return invalid()

	DB.run('UPDATE list SET list_name = ?, list_description = ?, list_public = ? WHERE list_id = ?', [
		name,
		String(data.description || '').trim(),
		parseInt(data.public, 10) ? 1 : 0,
		listing.get_id()
	])

	return persist(loadOwnedListing(userId, listing.get_id()).to_array())
}
